module.exports = __webpack_public_path__ + "static/media/man2.7a0f2120.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/man2.jpg
// module id = 85
// module chunks = 0